import { ButtonSizes, SpinnerBackdrop, Text } from "@/components/elements";
import { Button } from "@roc-digital/ui-web";
import { DataTable as PDataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode } from 'primereact/api';
import React from "react";
import { Link } from "@/components/elements/Link";


export interface DataTableData {
  name: string;
  value: number;
  percent?: number;
  article_id?: string;
}
export interface DataTableProps {
  data?: DataTableData[];
  loading: boolean;
  label: string;
  subtext: string;
  onExport?: (data: DataTableData, index: number) => void;
  extraColumns?: {field: string, label: string}[];
  noDefaultColumn?: boolean;
}

export function DataTable(props: DataTableProps) {

  const loading = !props.data || props.loading;
  const data = props.data || [];
  const rows = 10;
  const nameTemplate = React.useMemo(() => {
    if(!props.data?.[0]?.article_id) return undefined;
    return (data: DataTableData) => {
      return <Link to={`/articles/${data.article_id}`}>{data.name}</Link>
    } 
  }, [props.data?.[0]?.article_id])

  const extra = props.extraColumns || [];
  
  return <>
    <div className="">
      <div><Text size="strong">{props.label}</Text></div>
      <div><Text size="small" color="info" style={{fontSize: 12}}>{props.subtext}</Text></div>
      <PDataTable
        value={props.data}
        size="small"
        paginator={data.length > rows ? true :false}
        rows={rows} rowsPerPageOptions={[rows, 25, 50]}
        loading={loading}
        filters={{name: { value: null, matchMode: FilterMatchMode.CONTAINS }}}
        globalFilterFields={['name']}
        filterDisplay="row"
      >
        {props.noDefaultColumn !== true ?
          <Column field="name" header="Name" sortable filter={data.length > rows ? true :false} filterPlaceholder="Search by name" body={nameTemplate}></Column>
        : null}
        {props.noDefaultColumn !== true ?
          <Column field="value" header="Value" sortable style={{width: '150px'}}></Column>
        : null}
        {extra.map(e => (<Column key={e.field} field={e.field} header={e.label} sortable style={{width: '150px'}}></Column>))}
        {props.onExport ? (
          <Column header="Actions" body={(item, config) => {
          return props.onExport ? <>
            <Button size={ButtonSizes.small} clickEvent={() => props.onExport?.(item, config.rowIndex)}>Export</Button>
          </> : null
        }}></Column>
        ) : null}
      </PDataTable>
    </div>
  </>
}

